import React from 'react';

const ApiRootContext = React.createContext();
export default ApiRootContext;